// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__eVSYe","tab":"tabs_tab__Fs8wp","tabActive":"tabs_tabActive__Oxrdj"};